import { Component, Input, OnChanges, OnDestroy, ChangeDetectorRef, ViewChild, Output, EventEmitter } from '@angular/core';
import BenzAMRRecorder from 'benz-amr-recorder';
import * as $ from 'jquery';

@Component({
  selector: 'icc-audio',
  templateUrl: './icc-audio.component.html',
  styleUrls: ['./icc-audio.component.less'],
})
/*
HTML5 Audio标签能够支持wav, mp3, ogg, acc, webm等音频格式，
但平台内的amr格式的文件不被audio支持，故该组件目前只针对区别是否是amr两种情况
* */
export class IccAudioComponent implements OnChanges, OnDestroy {
  // 语音文件路径
  @Input() url: string;

  @Output() canplay: EventEmitter<any> = new EventEmitter<any>();

  @Output() error: EventEmitter<any> = new EventEmitter<any>();

  @ViewChild('audioview', { static: false }) audioView: any;

  /*以下属性针对amr格式的播放*/
  // 语音总长度
  duration: any;
  // 当前播放长度
  currentTime: any;
  // 是否是amr格式的音频
  isAmr = false;
  // 实例对象
  AMR: any;
  // 是否正在播放
  isRunning = false;
  // 定时器实例
  intervalIns: any;
  // 是否正在拖动，跳转音频播放位置
  isDragging = false;
  // 上一次拖动时的水平位置
  dragLastX: number;
  // 失败提示
  errorText: string;

  constructor(private cdr: ChangeDetectorRef) {}

  ngOnChanges() {
    this.errorText = '';
    if (typeof this.url === 'string' && this.url.endsWith('.amr')) {
      this.isAmr = true;
      // this.AMR = new BenzAMRRecorder();
      // this.AMR.initWithUrl(this.url).then(
      //   () => {
      //     if (this.AMR) {
      //       this.duration = this.AMR.getDuration().toFixed(2);
      //       this.currentTime = this.AMR.getCurrentPosition().toFixed(2);
      //       this.canplay.emit();
      //     }
      //   },
      //   err => {
      //     this.currentTime = '0:00';
      //     this.duration = '0:00';
      //     this.errorText = '解码失败';
      //     if(this.url !== '') this.error.emit();
      //   },
      // );
      this.amrLoad();
    } else {
      this.isAmr = false;
      this.AMR = null;
      if(this.intervalIns) {
        clearInterval(this.intervalIns);
        this.intervalIns = null;
      }
    }
  }
  ngOnDestroy() {
    this.currentTime = '0:00';
    this.duration = '0:00';
    if (this.intervalIns) {
      clearInterval(this.intervalIns);
    }
    this.errorText = '';
    if (this.AMR) {
      this.AMR.stop();
      this.AMR = null;
    }
  }

  /**
   * amr音频 load
   */
  amrLoad() {
    this.AMR = new BenzAMRRecorder();
    this.AMR.initWithUrl(this.url).then(
      () => {
        if (this.AMR) {
          this.duration = this.AMR.getDuration().toFixed(2);
          this.currentTime = this.AMR.getCurrentPosition().toFixed(2);
          this.canplay.emit();
        }
      },
      err => {
        this.currentTime = '0:00';
        this.duration = '0:00';
        this.errorText = '解码失败';
        console.log('error');
        if(this.url !== '') this.error.emit();
      },
    );
  }
  /**
   * 整合 play() 和 resume()
   */
  run() {
    if (this.AMR && !this.errorText) {
      if (Math.abs(this.currentTime - this.duration) < 0.05) {
        this.AMR.setPosition(0);
      }
      this.watchTime(true);
      this.isRunning = true;
      this.AMR.playOrResume();
    } else if(!this.isAmr && !this.errorText) {
      this.audioView.nativeElement.play();
    }
  }
  /**
   * pause()
   */
  pause() {
    if (this.AMR && !this.errorText) {
      this.watchTime(false);
      this.isRunning = false;
      this.AMR.pause();
    } else if(!this.isAmr && !this.errorText) {
      this.audioView.nativeElement.pause();
    }
  }
  /**
   * 
   * 重新加载音频
   */
  load() {
    if(typeof this.url === 'string' && this.url.endsWith('.amr')) {
      this.isAmr = true;
      this.amrLoad();
    } else {
      this.audioView.nativeElement.load();
    }
    // if (this.AMR && !this.errorText) {
    //   this.amrLoad();
    // } else if(!this.isAmr && !this.errorText) {
    //   this.audioView.nativeElement.load();
    // }
  }
  /**
   * 跟踪时间
   */
  watchTime(flag) {
    if (flag) {
      if (this.AMR) {
        this.duration = this.AMR.getDuration().toFixed(2);
      }
      if (!this.intervalIns && this.AMR) {
        this.intervalIns = setInterval(() => {
          this.currentTime = this.AMR.getCurrentPosition().toFixed(2);
          if (Math.abs(this.currentTime - this.duration) < 0.05) {
            this.currentTime = this.duration;
            this.isRunning = false;
            this.AMR.pause();
            this.watchTime(false);
          }
          this.cdr.detectChanges();
        }, 10);
      }
    } else if (this.intervalIns) {
      clearInterval(this.intervalIns);
      this.intervalIns = null;
    }
  }
  /**
   * 改变音频播放位置：开始拖动
   */
  dragStart(evt) {
    if (this.errorText) {
      return;
    }
    this.isDragging = true;
    this.pause();
    this.watchTime(false);
    this.dragLastX = evt.clientX;
  }
  /**
   * 改变音频播放位置：拖动中
   */
  dragging(evt) {
    if (this.errorText || !this.isDragging) {
      return;
    }
    const blockEl = $(evt.currentTarget).find('.amr-block');
    const marginLeft = parseFloat(blockEl.css('margin-left'));
    let diff = evt.clientX - this.dragLastX;
    switch (true) {
      case marginLeft + diff < 0:
        // 滑块位置在滑条左侧
        diff = -marginLeft;
        break;
      case marginLeft + diff <= 108:
        // 滑块位置在滑条上
        break;
      case marginLeft + diff > 108:
        // 滑块位置在滑条右侧
        diff = 108 - marginLeft;
        break;
    }
    blockEl.css('margin-left', marginLeft + diff + 'px');
    this.dragLastX = evt.clientX;
  }
  /**
   * 改变音频播放位置：结束拖动
   */
  dragEnd(evt) {
    if (this.errorText || !this.isDragging) {
      return;
    }
    this.isDragging = false;
    this.currentTime = (
      (parseFloat(
        $(evt.currentTarget)
          .find('.amr-block')
          .css('margin-left'),
      ) /
        108) *
      this.duration
    ).toFixed(2);
    this.AMR.setPosition(this.currentTime);
  }

  handleCanplay() {
    this.canplay.emit();
  }

  handelError() {
    if(this.url !== '') this.error.emit();
  }
}
